import axios from 'axios';

// When CRA "homepage" is a subpath, use PUBLIC_URL so /api becomes /your-app/api (same origin as static files).
const rawPublic = process.env.PUBLIC_URL;
const PUBLIC_PATH_PREFIX =
  rawPublic && rawPublic !== '.' ? String(rawPublic).replace(/\/$/, '') : '';

// Prefer REACT_APP_API_URL if set. Otherwise same-origin `/api` or `{PUBLIC_URL}/api`.
// In dev, src/setupProxy.js forwards /api → backend.
const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (PUBLIC_PATH_PREFIX ? `${PUBLIC_PATH_PREFIX}/api` : '/api');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if it exists
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Si c'est un FormData, ne pas définir Content-Type (laisser le navigateur le faire)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    // Don't auto-redirect on magic link verification errors - let the component handle it
    const isMagicLinkVerify = url.includes('/magic-link-verify');
    // Failed login/register return 401/400 — not "session expired"
    const isCredentialAttempt =
      url.includes('/auth/login') || url.includes('/auth/register');

    if (error.response?.status === 401 && !isMagicLinkVerify && !isCredentialAttempt) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Resolve a stored path like /uploads/foo.jpg to a browser URL.
// DB paths stay /uploads/... but the browser loads /api/uploads/... so nginx (often only proxying /api to Node) can serve files.
// Dev: full URL http://localhost:5001/api/uploads/... hits Express static.
export const resolveUploadUrl = (pathFromApi) => {
  if (!pathFromApi || typeof pathFromApi !== 'string') return pathFromApi;
  if (!pathFromApi.startsWith('/')) return pathFromApi;
  const pathWithApi =
    pathFromApi.startsWith('/uploads') ? '/api' + pathFromApi : pathFromApi;
  const base = API_BASE_URL.replace(/\/api\/?$/, '');
  if (!base) {
    return pathWithApi;
  }
  if (
    typeof window !== 'undefined' &&
    window.location.protocol === 'https:' &&
    base.startsWith('http:')
  ) {
    return pathWithApi;
  }
  return `${base}${pathWithApi}`;
};

export default api;


